// Pure helpers for "open solution in a new tab" support (PSTUDIO-2541).
// No React / no design-system imports — unit-testable in the node env.

/**
 * Canonical Pro Studio solution route: /{projectId}/{botId} (matches prostudio.xstate cb).
 * `filter(Boolean)` keeps the result safe by construction: an empty projectId can never yield a
 * protocol-relative `//host` (open-redirect shape) and a missing botId never appends `/undefined`
 * — both are broken/unsafe hrefs. botId is optional because the source `Solution.id` is `string?`.
 */
export function buildSolutionHref(projectId: string, botId?: string): string {
  return `/${[projectId, botId].filter(Boolean).join('/')}`;
}

// isPlainLeftClick now lives in @pypestream/utils (shared with design-system's mega menu, PSTUDIO-3824).
// Imported from the React-free `/mouse` subpath so a WC consumer never pulls the utils barrel's
// transitive React deps. Re-exported here so existing pro-studio imports keep working unchanged.
export { isPlainLeftClick } from '@pypestream/utils/mouse';
